import { render, staticRenderFns } from "./ProjectBlock.vue?vue&type=template&id=dffd1374&scoped=true"
import script from "./ProjectBlock.vue?vue&type=script&lang=js"
export * from "./ProjectBlock.vue?vue&type=script&lang=js"
import style0 from "./ProjectBlock.vue?vue&type=style&index=0&id=dffd1374&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dffd1374",
  null
  
)

export default component.exports